<template>
    <div id="update-holidayplus-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>Online Booking URL</label>
                    <a-input
                        v-model="clone.payload.bookingURL"
                        v-validate="'required'"
                        placeholder="https://caglatur.holidayplus.pro/onlinehotelbooking/"
                    />
                </div>
            </div>
        </a-form>

        <div class="form-footer mt-4">
            <div class="actions">
                <a-button @click="handleCancel">{{ $t("wp.cancel") }}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("billing.update") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "UpdateHolidayPlusChannel",
    components: {},
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.channel),
            loading: false,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            stories: (state) => state.CB.stories,
        }),
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
        }),
        handleCancel() {
            this.$emit("cancel");
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.clone;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success(this.$t("ticimax.channelUpdated"));
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error(this.$t("ticimax.channelUpdateFailed"));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#update-teamgram-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }

    .webhook-info {
        display: flex;
        gap: 5px;
        justify-content: center;
        padding: 5px;
        overflow-wrap: anywhere;

        .anticon {
            &:hover {
                color: var(--color-text-info-hover);
            }
        }
    }
}
</style>

<style lang="scss">
.new-waba {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
